export default "__VITE_ASSET__CI87EbZo__"